export const formatDateDjango = (date) => {
  if (date) {
    const splittedDate = date.split('T')[0];
    const [year, month, day] = splittedDate.split('-');
    return `${day}/${month}/${year}`;
  }
  return '';
};
